// material-ui
import { Theme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

// project import
import Search from './Search';
// import Message from './Message';
// import Profile from './Profile';
import Localization from './Localization';
// import Notification from './Notification';
// import Customization from './Customization';
import ThemeSwitch from './ThemeSwitch';
import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// types
import { MenuOrientation } from 'types/config';
import { useMemo } from 'react';
import WC from './wc';
import { getDomainName } from 'utils/commonFunctions';
import Logout from './Logout';

const domain = getDomainName();
const isIONetgateDomain = domain.includes('io-netgate');
const isIOMDomain = domain.includes('io-market');
// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation, i18n } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {!downLG && <Search />}
      {/* {!downLG && megaMenu} */}
      {!downLG && localization}
      {/* {downLG && <Box sx={{ width: '100%', ml: 1 }} />} */}

      {/* <Notification /> */}
      {/* <Message /> */}
      {/* <Customization /> */}
      {/* {!downLG && <Profile />} */}
      <ThemeSwitch />
      {!downLG  && isIOMDomain && <WC />}
      {!downLG  && isIONetgateDomain && <Logout />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
